import { ChannelIOFn } from "../types/channelTalk";
import { useEffect } from "react";

const useChannelTalk = () => {
  useEffect(() => {
    (function () {
      const w = window;

      if (w.ChannelIO) {
        w.console.error("ChannelIO script included twice.");
        return;
      }

      const ch = function (...args: unknown[]) {
        ch.c(args);
      } as ChannelIOFn;

      ch.q = [];
      ch.c = function (args: unknown[]) {
        ch.q.push(args);
      };

      w.ChannelIO = ch;

      function l() {
        if (w.ChannelIOInitialized) {
          return;
        }
        w.ChannelIOInitialized = true;
        const s = document.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = "https://cdn.channel.io/plugin/ch-plugin-web.js";
        const x = document.getElementsByTagName("script")[0];
        if (x.parentNode) {
          x.parentNode.insertBefore(s, x);
        }
      }

      if (document.readyState === "complete") {
        l();
      } else {
        w.addEventListener("DOMContentLoaded", l);
        w.addEventListener("load", l);
      }
    })();

    window.ChannelIO?.("boot", {
      pluginKey: process.env.NEXT_PUBLIC_CHANNEL_PLUGIN_KEY,
      zIndex: 1999,
    });

    // 디버깅을 위한 로그 추가
    // console.log('ChannelTalk 초기화 시도');
    // console.log('Plugin Key:', process.env.NEXT_PUBLIC_CHANNEL_PLUGIN_KEY);
    // console.log('ChannelIO 객체 존재 여부:', !!window.ChannelIO);
  }, []);
};

export default useChannelTalk;
